import { render, staticRenderFns } from "./RefundCard.vue?vue&type=template&id=2fda051f&scoped=true&"
import script from "./RefundCard.vue?vue&type=script&lang=ts&"
export * from "./RefundCard.vue?vue&type=script&lang=ts&"
import style0 from "./RefundCard.vue?vue&type=style&index=0&id=2fda051f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda051f",
  null
  
)

export default component.exports